<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="COPYRIGHT"><br/>Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /<br/>P.O. Box 163, Cambridge <span class="scall">CB3 9PU</span> U.K. <br/>www.eerdmans.com<br/><br/>© 1996 N. T. Wright<br/>All rights reserved<br/>First U.K. edition published 1996 by<br/>Society for Promoting Christian Knowledge<br/>36 Causton Street, London <span class="scall">SW1P 4ST</span><br/>First American edition published 1997 by<br/>Wm. B. Eerdmans Publishing Co.<br/>New edition published 2014<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">ISBN 978-0-8028-7177-0</p>
<p class="CIP">eISBN 978-1-4674-2884-2 (ePub)</p>
<p class="CIP">eISBN 978-1-4674-1156-1 (Kindle)</p>
<p class="URL"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?197f76fd